export enum MasterOrderErrorType {
  MasterOrderNotFound = 'MasterOrderNotFound',
  BeeBusinessNotFound = 'BeeBusinessNotFound',
  ConsultantNotFound = 'ConsultantNotFound',
  IncorrectOrderType = 'IncorrectOrderType',
  IncorrectPaymentStatus = 'IncorrectPaymentStatus',
  IncorrectCountry = 'IncorrectCountry',
}
